import { render, staticRenderFns } from "./TheLayoutToTopFab.vue?vue&type=template&id=d6b28f88&scoped=true&"
import script from "./TheLayoutToTopFab.vue?vue&type=script&lang=js&"
export * from "./TheLayoutToTopFab.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutToTopFab.vue?vue&type=style&index=0&id=d6b28f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b28f88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFabTransition,VIcon})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Scroll})
